export default __webpack_public_path__ + "static/media/04.26.24 Minutes of the Annual Shareholdings' Meeting.383ba525.pdf";